module.exports = __webpack_public_path__ + "img/noimg.c1b8e3bf.svg";